import React from "react";
import CarecoApi from "@/api/careco-api";
import EncounterApi from "@/api/encounter-api";
import WebSocketApi from "@/api/websocket-api";

export interface AppState {
  carecoApi?: CarecoApi | null
  encounterApi?: EncounterApi | null
  webSocketApi?: WebSocketApi | null
  updateState: (newState: Partial<AppState>) => void
}

const defaultState: AppState = {
  carecoApi: null,
  encounterApi: null,
  webSocketApi: null,
  updateState: () => {},
};

export const CarecoApiContext = React.createContext<AppState>(defaultState);
